import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    playTrack,
    pauseTrack,
    stopTrack,
    clear,
    seekTrack,
    setAudio,
    setSlider
} from './actions';

export const useAudio = () => {
    const dispatch = useDispatch();
    const audioState = useSelector(state => state.audio);

    return {
        updateSlider: payload => {
            dispatch(setSlider(payload))
        },
        updateAudio: audio => {
            dispatch(setAudio(audio))
        },
        close: () => {
            dispatch(clear())
        },
        play: payload => {
            dispatch(playTrack(payload))
        },
        pause: () => dispatch(pauseTrack()),
        stop: () => dispatch(stopTrack()),
        seek: (time) => {
            time = audioState.duration * time
            console.log({ time, audioState });

            dispatch(seekTrack(time));
        },
        currentTrack: audioState.currentTrack,
        isPlaying: audioState.isPlaying,
        autoplay: audioState.autoplay,
        isWatching: audioState.isWatching,
        currentTime: audioState.currentTime,
        duration: audioState.duration,
        lastPlayedId: audioState.lastPlayedId,
        slider: audioState.slider
    };
};